import {CsvReadItem} from './PromotionQuestionsState';
import api from '../../api';
import {buildValidator} from 'src_common/common/mobx-utils/buildValidator';
import {ResponseGetQuestionsIO} from './types';
import * as t from 'io-ts';

const decodeResponse = buildValidator('get marketing questions -> ResponseIO', ResponseGetQuestionsIO, true);

export const fetchQuestions = (): Promise<Array<CsvReadItem>> => {
    return new Promise((resolve, reject) => {
        const url = '/marketing-questions';

        api.get(url)
            .then((data: t.TypeOf<typeof ResponseGetQuestionsIO>) => {
                const decodeResult = decodeResponse(data);
                if (decodeResult instanceof Error) {
                    reject(decodeResult);
                }
                resolve(data);
            }).catch((error: Error)=>{
                reject(error);
            });
    });
};
